import React from 'react';

const Loader = () => {
  return <p>Loading...</p>;
};

export default Loader;
